export default __webpack_public_path__ + "static/media/first-deposit.2302995f.svg";